module.exports = __webpack_public_path__ + "static/media/KW12_vystuz.2931c84c.png";